import checkout from "./form";

const {
  formField: { domain, username, password },
} = checkout;

export default {
  [domain.name]: "",
  [username.name]: "",
  [password.name]: "",
};
